import api_fabric from "../../api/ApiFabric";
import currency from "@libs/util/CurrencyHelper";
import prepareOffers, { POINT_OFFER_CATEGORY, BOOK_OFFER_CATEGORY } from "./helpers/prepareOffers";

/**
 *
 * @return {BpBilling}
 */
const api = function() {
  return api_fabric.getInstance("Billing", true);
};
const billing = {
  namespaced: true,
  state: {
    offers: [],
    currency: currency.getDefaultCurrency(),
    payment_frame: {
      show: false,
      url: null,
    },
  },
  mutations: {
    writeOffersList(state, offers) {
      state.offers = offers;
    },
    updatePaymentFrameState(state, data) {
      state.payment_frame.show = data.show;
      state.payment_frame.url = data.url;
    },
    changeCurrency(state, { currency }) {
      state.currency = currency;
    },
  },
  getters: {
    getPointOffers(state) {
      return state.offers.filter(order => order.category === POINT_OFFER_CATEGORY);
    },
    getBookOffers(state) {
      return state.offers.filter(order => order.category === BOOK_OFFER_CATEGORY);
    },
    getPaymentFrameData(state) {
      return state.payment_frame;
    },
  },
  actions: {
    getOffers({ commit }) {
      return api()
        .getOffers()
        .then(response => {
          if (response.success) {
            const offers = prepareOffers(response.success.data.data);
            commit("writeOffersList", offers);
            return offers;
          }
        });
    },
    buyOffer(order_id) {
      return api().buyOffer(order_id);
    },
    showPaymentFrame({ commit }, { url }) {
      commit("updatePaymentFrameState", { url: url, show: true });
    },
    hidePaymentFrame({ commit }) {
      commit("updatePaymentFrameState", { url: null, show: false });
    },
    changeCurrency({ commit }, { currency }) {
      commit("changeCurrency", { currency });
    },
  },
};
export default billing;
